import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';
import { ReCaptchaCheckbox } from '@/Domain/components/Auth/ReCaptchaCheckbox';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Input } from '@/Domain/components/Shared/Input/Input';
import { Spinner } from '@/Domain/components/Shared/Spinner';
import { ChevronLeftIcon } from '@/Domain/components/icons/ChevronLeft.icon';
import { useForgotPasswordHook } from '@/Domain/hooks/Auth/useForgotPassword.hook';

// TODO: try do remove recaptcha V2
export const ForgotPasswordPage = () => {
  const { t } = useTranslation(['forgot_password, forgot_password_success']);

  const navigate = useNavigate();
  const { track } = useAnalytics();

  const { register, errors, control, handleSubmit, useV2, forgot, onSubmit, onVerify } =
    useForgotPasswordHook();

  const handleClick = () => {
    track('forgot_password_back_success_click', {
      event_category: 'Forgot password',
      event_label: 'forgot_password_form',
    });

    navigate('/', { viewTransition: true });
  };

  if (forgot.isSuccess) {
    return (
      <>
        <h1 className="font-semibold mb-8 text-xl text-center text-black">
          {t('forgot_password_success:title')}
        </h1>
        <p className="text-base">{t('forgot_password_success:description')}</p>
        <div className="flex mt-4 justify-center">
          <Button variant="dark" className="w-full" onClick={handleClick}>
            {t('forgot_password_success:link')}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      <h1 className="font-semibold mb-8 text-xl text-center text-black relative">
        <Link
          to="/"
          className="text-gray-800 absolute top-1/2 left-0 transform -translate-y-1/2"
          onClick={() =>
            track('forgot_password_back_click', {
              event_category: 'Forgot password',
              event_label: 'forgot_password_form',
            })
          }
        >
          <ChevronLeftIcon className="h-4" />
        </Link>{' '}
        {t('forgot_password:title')}
      </h1>
      <p className="text-base">{t('forgot_password:label')}</p>
      <form
        id="forgot-password-form"
        className="mt-2 flex flex-col gap-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div>
          <label htmlFor="email" className="text-sm text-gray-800">
            {t('forgot_password:form.email')}
          </label>
          <Input
            id="email"
            placeholder={t('forgot_password:form.email_placeholder')}
            error={!!errors.email}
            {...register('email')}
          />
          {errors.email && <span className="text-sm text-red-500">{errors.email.message}</span>}
        </div>
        <GoogleReCaptcha onVerify={onVerify} />
        <Button variant="dark" type="submit" disabled={forgot.isPending}>
          {forgot.isPending ? <Spinner /> : t('forgot_password:button.submit')}
        </Button>
        {useV2 && (
          <Controller
            name="recaptcha_response_v2"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange }, fieldState: { invalid } }) => (
              <ReCaptchaCheckbox onChange={onChange} isInvalid={invalid} />
            )}
          />
        )}
      </form>
    </>
  );
};

export default ForgotPasswordPage;
